import React from "react";

/**
 * @description Handles the admin settings
 */
export default function AdminSettings() {
  return <div>AdminSettings</div>;
}
